// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:767px){.NsSlottedDropdown__small[data-v-74e9cd5e]{margin-top:6px;width:100%}.NsSlottedDropdown__small[data-v-74e9cd5e]  .dropdown-area{flex-grow:1}.NsSlottedDropdown__small[data-v-74e9cd5e]  .current-selection{min-height:35px;height:35px;border-radius:6px}.NsSlottedDropdown__small[data-v-74e9cd5e]  .selected-item{flex-grow:1;justify-content:center}}", ""]);
// Exports
module.exports = exports;
